module.exports = __webpack_public_path__ + "img/lk-hero-img-center.2eb0a06f.svg";